import { FC, useEffect, useState } from 'react';
import { Tabs, Typography } from 'antd';
import { TbUsers, TbUsersGroup, TbUserShield, TbWorldCheck } from 'react-icons/tb';
import { Navigate, Route, Routes, useNavigate, useLocation } from 'react-router-dom';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { ErrorView } from '@/shared';

import Members from './views/01-Members';
import Roles from './views/02-Roles';
import { TeamDetail, TeamsList } from './views/03-Teams';
import VerifiedDomains from './views/03-VerifiedDomains';

const Permissions: FC = (): JSX.Element => {
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const url = '/settings/workspace/permissions';
    const path = url;

    const onChangeTab = (newActiveKey: string) => {
        navigate(`${url}/${newActiveKey}`);
    };

    useEffect(() => {
        setLoading(false);
    }, []);

    const items = [
        {
            key: 'members',
            label: (
                <>
                    <TbUsersGroup size='1rem' style={{ verticalAlign: '-0.175rem', marginRight: '0.25rem' }} />
                    Members
                </>
            ),
        },
        {
            key: 'roles',
            label: (
                <>
                    <TbUserShield size='1rem' style={{ verticalAlign: '-0.175rem', marginRight: '0.25rem' }} />
                    Roles
                </>
            ),
        },
        {
            key: 'teams',
            label: (
                <>
                    <TbUsers size='1rem' style={{ verticalAlign: '-0.175rem', marginRight: '0.25rem' }} />
                    Teams
                </>
            ),
        },
        {
            key: 'domains',
            label: (
                <>
                    <TbWorldCheck size='1rem' style={{ verticalAlign: '-0.175rem', marginRight: '0.25rem' }} />
                    Verified Domains
                </>
            ),
        },
    ];

    const location = useLocation();

    const activeKey = location.pathname.split('/')[4];

    const { token } = useAntDesignTheme();

    return (
        <div style={{ marginRight: '1.5rem' }}>
            <Typography.Title>Permissions</Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary, marginBottom: 0 }}>
                Manage who has access to this workspace
            </Typography.Paragraph>
            <Tabs activeKey={activeKey} animated={true} onChange={onChangeTab} items={items} />

            <Routes>
                <Route index element={<Navigate to={`${url}/members`} replace />} />

                <Route path='members' element={<Members />} />

                <Route path='roles' element={<Roles />} />

                <Route path='teams' element={<TeamsList />} />

                <Route path='teams/:teamId/*' element={<TeamDetail />} />

                <Route path='domains' element={<VerifiedDomains />} />

                <Route path='*' element={<ErrorView />} />
            </Routes>
        </div>
    );
};

export default Permissions;
